<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="timer"
  [fullScreen]="false"
  ><p style="color: white">L oading...</p></ngx-spinner>

<div class="text-center">
  <img *ngIf="isLoading" src="./assets/images/loading04.gif" style="width: 10rem;">
</div>

<div class="content-wrapper" style="min-height: 307px">
  <div class="row" *ngIf="userdata.userlevel !== '15'">
    <div class="col-lg-12">
      <div class="row">
        <div class="card bg-primary">
          <div class="card-header">
            ระบบขอเงินส่งเสริมออนไลน์
            <div class="card-tools">
              <button
                type="button"
                class="btn btn-tool"
                data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>
          <div class="card-body" [formGroup]="askformoney">
            <input
              type="text"
              class="form-control"
              list="farmer"
              placeholder="เลือกชาวไร่ รหัส 10 หลัก"
              id="codefm"
              (change)="goloaddata()"
            />
            <datalist id="farmer">
              <option *ngFor="let item of famerlist">
                {{ item.fmcode_b1 }} {{ item.fmname }} จำนวนแปลง {{ item.cnt }}
                <lable *ngIf="item.approve === 'Y'">เบิกได้</lable>
                <lable *ngIf="item.PromiseIN == 0">สัญญายังไม่ผ่าน</lable>
                <lable *ngIf="item.zoneban === 'Y'">อยู่โซนต้องห้าม</lable>
              </option>
            </datalist>
            <div class="card" style="color: black">
              <div class="card-header">ข้อมูลแปลงปี 65/66</div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-8">
                    <p *ngFor="let item of canget">
                      วงเงินทั้งหมด :
                      {{ item.sumlimit.toLocaleString() }} วงเงินที่ขอแล้ว :
                      {{ item.money_amt.toLocaleString() }} วงเงินคงเหลือ :
                      {{ item.leftlimit.toLocaleString() }}
                    </p>
                    <div class="card">
                      <div class="card-body">
                        <table class="table" #farmertable>
                          <thead>
                            <tr>
                              <td>เลขแปลง</td>
                              <td>โซน</td>
                              <td>ชาวไร่</td>
                              <td>นสส.</td>
                              <td>ประเภท</td>
                              <td>กรรมสิทธิ์</td>
                              <td>พื้นที่</td>
                              <td>ปลูกเสร็จ</td>
                              <td>วงเงิน</td>
                              <td>เงินที่ขอ</td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              *ngFor="let item of dataonefarmer"
                              (click)="snaponedata(item.itid)"
                            >
                              <td>{{ item.intlandno }}</td>
                              <td>{{ item.supzone }}</td>
                              <td>{{ item.fmname }}</td>
                              <td>{{ item.supcode }}</td>
                              <td>{{ item.CaneTypeName }}</td>

                              <td>
                                <label *ngIf="item.Plottype == 1">เช่า</label>
                                <label *ngIf="item.Plottype == 2">ตนเอง</label>
                              </td>
                              <td>{{ item.landvalue }}</td>
                              <td>{{ item.PlantDateTH }}</td>
                              <td>{{ item.credit_amount | number }}</td>
                              <td>
                                <div *ngFor="let li of crdamt">
                                  <label
                                    *ngIf="
                                      li.intlandno.trim() ===
                                      item.intlandno.trim()
                                    "
                                    >{{ li.sum_money_amt | number }}</label
                                  >
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <!-- ฟอร์มขอเบิกสินเชื่อ -->
                  <div class="col-md-4" [hidden]="ckfarmer">
                    <div class="card">
                      <div class="card-header bg-warning">
                        ฟอร์มขอเบิกเงินส่งเสริมปี 65/66 [
                        <label id="fmnamelable"></label> ]
                      </div>
                      <div class="card-body" [formGroup]="askformoney">
                        <input
                          type="text"
                          class="form-control"
                          id="plantnum"
                          placeholder="หมายเลขแปลง"
                          disabled
                        />
                        <br />
                        <input
                          type="text"
                          class="form-control"
                          id="anyreason"
                          placeholder="เหตุผล"
                          formControlName="comment"
                          required
                        />
                        <br />
                        <input
                          type="number"
                          min="1.00"
                          step="1.00"
                          data-number-to-fixed="2"
                          class="form-control"
                          id="countmoney"
                          placeholder="จำนวนเงิน"
                          formControlName="count"
                          required
                          
                        />
                        <br />
                        <input
                          type="file"
                          class="form-control"
                          id="customFile"
                          accept="image/png, image/jpeg"
                          (change)="onFileUpload($event.target.files)"
                        />
                        <!-- <label class="custom-file-label" for="customFile">เลือกไฟล์</label> -->
                        <hr />
                        <button class="btn btn-warning" (click)="gosave()">
                          <i class="far fa-save"></i> บันทึก
                        </button>
                        &nbsp; &nbsp;
                        <button class="btn btn-info" (click)="cleartext()">
                          กรอกใหม่
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- ฟอร์มขอเบิกสินเชื่อ -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ข้อมูลการขอสินเชื่อออนไลน์ปี 64/65 -->
      <div class="row">
        <div class="card">
          <div class="card-header bg-primary">
            <b>ข้อมูลการขอสินเชื่อออนไลน์ปี 65/66</b>
          </div>
          <div class="card-body">
            <table class="table" #moneydata>
              <thead>
                <tr>
                  <td>เลขที่</td>
                  <td>วันที่</td>
                  <td>ชื่อ</td>
                  <td>แปลง</td>
                  <td>เหตุผล</td>
                  <td>จำนวนเงิน</td>
                  <td>สถานะ</td>
                  <td><i class="fas fa-print"></i> พิมพ์</td>
                  <td><i class="fas fa-ban"></i> ยกเลิก</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let item of datafinance"
                  [ngClass]="item.over_limit == '1' ? 'bg-danger' : ''"
                >
                  <td>{{ item.docid }}</td>
                  <td>{{ item.datepost_th }}</td>
                  <td>{{ item.fmname }}</td>
                  <td>{{ item.intlandno }}</td>
                  <td>{{ item.comment1 }}</td>
                  <td>{{ item.money_amt.toLocaleString() }}</td>
                  <td>{{ item.docdesc }}</td>
                  <td>
                    <a
                      [routerLink]="['/printaskformoney']"
                      routerLinkActive="active"
                      target="_blank"
                    >
                      <button
                        class="btn btn-warning"
                        (click)="getfmcode(item.fmcode)"
                      >
                        <i class="fas fa-print"></i>
                      </button>
                    </a>
                  </td>
                  <td>
                    <button
                      class="btn btn-danger btn-sm"
                      (click)="cancledoc_id(item.docid)"
                      *ngIf="item.doc_status == 0"
                    >
                      <mat-icon>highlight_off</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- ข้อมูลการขอสินเชื่อออนไลน์ปี 64/65 -->
    </div>
  </div>

  <div class="row" *ngIf="userdata.userlevel === '15'">
    <div class="col-lg-12">
      <!-- ข้อมูลการขอสินเชื่อออนไลน์ปี 64/65 -->
      <div class="row">
        <div class="card">
          <div class="card-header bg-primary">
            ข้อมูลการขอสินเชื่อออนไลน์ปี 65/66
            <b class="text-warning">เกินวงเงิน</b>
            <div class="card-tools">
              <button (click)="getfinancebyzone()" type="button" class="btn btn-tool" title="รีเฟรซข้อมูล"><i class="fas fa-sync-alt"></i></button>
              <!--<button type="button" class="btn btn-tool" data-card-widget="card-refresh" data-source="widgets.html" data-source-selector="#card-refresh-content" data-load-on-init="false"><i class="fas fa-sync-alt"></i></button>
              <button type="button" class="btn btn-tool" data-card-widget="maximize"><i class="fas fa-expand"></i></button>
              <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i></button>
              <button type="button" class="btn btn-tool" data-card-widget="remove"><i class="fas fa-times"></i></button> -->
            </div>
          </div>
          <div class="card-body">
            <table #moneydata class="table table-hover table-head-fixed text-nowrap">
              <thead>
                <tr>
                  <td>เลขที่</td>
                  <td>วันที่</td>
                  <td>ชื่อ</td>
                  <td>แปลง</td>
                  <td>เหตุผล</td>
                  <td>จำนวนเงิน</td>
                  <td>สถานะ</td>
                  <td><i class="fas fa-bars"></i> Action</td>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of datafinance">
                  <td>{{ item.docid }}</td>
                  <td>{{ item.datepost_th }}</td>
                  <td>{{ item.fmname }}</td>
                  <td>{{ item.intlandno }}</td>
                  <td>{{ item.comment1 }}</td>
                  <td>{{ item.money_amt.toLocaleString() }}</td>
                  <td>{{ item.docdesc }}</td>
                  <td class="">
                    <button 
                      (click)="forwardtoFN(item.docid, item.money_amt, item.comment1, item.fmname, item.datepost_th)"
                      *ngIf="item.doc_status == 2"
                      type="button" class="btn  btn-sm btn-link" title="ส่งต่อสินเชื่อ"><i class="fas fa-forward"></i></button>
                    <a [routerLink]="['/printaskformoney']" routerLinkActive="active" target="_blank">
                      <button 
                        (click)="getfmcode(item.fmcode)" type="button" class="btn  btn-sm btn-link" title="พิมพ์ใบแนบเกี้ยว">
                        <i class="fas fa-print"></i>
                      </button>
                    </a>
                    <button 
                      (click)="cancledoc_id(item.docid)"
                      *ngIf="item.doc_status == 2 || item.doc_status == 0"
                      type="button" class="btn  btn-sm btn-link" title="ยกเลิกเกี้ยว"><i class="fas fa-ban"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- ข้อมูลการขอสินเชื่อออนไลน์ปี 64/65 -->
    </div>
  </div>
</div>


<!-- Modal กลุ่มบำรุง -->
<div class="modal fade" id="forwardtofn" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <form class="needs-validation" #frm_forwardfn="ngForm">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header bg-primary">
          <h1><mat-icon>forward</mat-icon> ส่งต่อเกี้ยวไปสินเชื่อ</h1>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row mt-1">
            <blockquote class="blockquote">
              <p class="text-primary">{{ valuesTomodal[3] }}</p>
              <footer class="blockquote-footer">เลขที่คำขอ {{ valuesTomodal[0] }} เมื่อ {{ valuesTomodal[4] }}</footer>
            </blockquote>
          </div>

          <input type="hidden" 
            #e_docid="ngModel" ngModel name="e_docid" id="e_docid"
            [(ngModel)]="valuesTomodal[0]" readonly required>
          
          <div class="row mt-1">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">จำนวนเงินที่ขอ </span>
              </div>
              <input #e_money_amt="ngModel" ngModel name="e_money_amt" id="e_money_amt" class="form-control"
                [ngClass]="{ 'is-invalid' : e_money_amt.invalid && (e_money_amt.dirty || e_money_amt.touched)}"
                type="number" [(ngModel)]="valuesTomodal[1]" required>
                <!-- (keyup)="CommaFormatted($event)"
                (keydown)="numberCheck($event)" -->
              <div class="invalid-feedback">
                  <span *ngIf="e_money_amt.hasError('required')">กรุณากรอกจำนวนเงินที่ขอ</span>
              </div> 
            </div>
          </div>  
          <div class="row mt-1">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">เหตุผลการขอเกี้ยว </span>
            </div>
              <input #e_comment1="ngModel" ngModel name="e_comment1" id="e_comment1" class="form-control"
              [ngClass]="{ 'is-invalid' : e_comment1.invalid && (e_comment1.dirty || e_comment1.touched)}"
              type="text" [(ngModel)]="valuesTomodal[2]" required>
            <div class="invalid-feedback">
                <span *ngIf="e_comment1.hasError('required')">กรุณากรอกจำนวนเงินที่ขอ</span>
            </div>
            </div>    
          </div>
        </div>
        <div class="modal-footer">
          <button (click)="saveforwardtoFN(frm_forwardfn.value)" [disabled]="frm_forwardfn.invalid"
            type="submit" class="btn btn-outline-success" data-dismiss="modal">
            <i class="fas fa-save"></i> Save
          </button>
          <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </form>

</div>
<!-- MOdal -->
<app-footer></app-footer>
